import {
  LOAD_NEWS_COMPLETE,
  LOAD_DETAIL_NEW_COMPLETE,
  LOAD_MORE_NEWS,
  LIKE_NEWS,
  FAVORITE_NEWS,
  LOAD_NEWS,
  ADVICE_MORE_NEWS,
  LOAD_NEWS_STICKY_COMPLETE,
  LOAD_NEWS_HIGHLIGHT_COMPLETE,
  LOAD_COMMENTS,
  LOAD_COMMENTS_COMPLETE,
  INSERT_COMMENT,
  REPLY_COMMENT,
  DELETE_COMMENT,
  LOAD_ALL_REPLIES_COMMENT,
  CHANGE_PAGE_COMMENTS,
  UNLIKE_NEWS,
  UNFAVORITE_NEWS
} from '../constants/actionTypes';
import {
  POSITION_STICKY,
  POSITION_TIMELINE,
  POSITION_HIGHLIGHT,
  PAGE_HOME_ID
} from '../constants/content';
import { getNewById, getAllNewsPage } from '../utils/apiNews';
import {
  getComments,
  insertComment,
  deleteComment,
  deleteCommentA3mil,
  getReplies,
  postLike,
  postReadLater,
  deleteLike,
  deleteReadLater
} from '../utils/apiSocial';

const getNewsLike = (dispatch, news) =>
  news
    .filter(item => item.socialInfo?.liked)
    .map(item => dispatch({ type: LIKE_NEWS, id: item.baseContentId }));

const getFavoriteNews = (dispatch, news) =>
  news
    .filter(item => item.socialInfo?.readLater)
    .map(item => dispatch({ type: FAVORITE_NEWS, id: item.baseContentId }));

let peticionAcabada = true;

export const loadNewsComplete = response => ({
  type: LOAD_NEWS_COMPLETE,
  news: response.content,
  total: response.total,
  page: response.page,
  size: response.size
});

export const loadNewDetailComplete = response => ({
  type: LOAD_DETAIL_NEW_COMPLETE,
  detail: response,
  id: response.id
});

export const getNews = (pageId = PAGE_HOME_ID) => (dispatch, getState) =>
  getAllNewsPage({
    page: getState().news.page,
    size: 10,
    pageId,
    position: POSITION_TIMELINE
  }).then(response => {
    getNewsLike(dispatch, response.content);
    getFavoriteNews(dispatch, response.content);
    dispatch(loadNewsComplete(response));
    return response;
  });

export const checkNews = (news, pageId = PAGE_HOME_ID) => (
  dispatch,
  getState
) =>
  getAllNewsPage({
    page: getState().news.page,
    pageId,
    pageNumber: 0,
    orderby: 'CREATION_DATE',
    order: 'desc',
    position: POSITION_TIMELINE
  }).then(response => {
    if (response[0].id !== news[0].id) {
      dispatch({
        type: ADVICE_MORE_NEWS
      });
    }
    return response;
  });

export const loadNews = () => (dispatch, getState) => {
  const { news } = getState().news;
  if (!news.length) {
    dispatch({ type: LOAD_NEWS });
    return dispatch(getNews());
  }
  return dispatch(checkNews(news));
};

export const loadNewsSticky = (pageId = PAGE_HOME_ID) => dispatch =>
  getAllNewsPage({ position: POSITION_STICKY, pageId }).then(news => {
    if (news.length) {
      getNewsLike(dispatch, news);
      getFavoriteNews(dispatch, news);
      dispatch({ type: LOAD_NEWS_STICKY_COMPLETE, news });
      return news;
    }
    return false;
  });

export const loadNewsHighlight = (pageId = PAGE_HOME_ID) => dispatch =>
  getAllNewsPage({ position: POSITION_HIGHLIGHT, pageId }).then(news => {
    getNewsLike(dispatch, news);
    getFavoriteNews(dispatch, news);
    dispatch({ type: LOAD_NEWS_HIGHLIGHT_COMPLETE, news });
    return news;
  });

export const refreshNews = () => dispatch => {
  dispatch({ type: LOAD_NEWS });
  dispatch(getNews());
};

export const loadNewDetail = id => dispatch =>
  getNewById(id).then(news => {
    if (news.socialInfo?.liked) {
      dispatch({ type: LIKE_NEWS, id: news.id });
    }

    if (news.socialInfo?.readLater) {
      dispatch({ type: FAVORITE_NEWS, id: news.id });
    }
    dispatch(loadNewDetailComplete(news));
  });

export const loadNewsMore = () => dispatch => {
  dispatch({ type: LOAD_MORE_NEWS });
  dispatch(getNews());
};

export const loadComments = contentId => (dispatch, getState) => {
  const stateComment = getState().news.comments;
  dispatch({ type: LOAD_COMMENTS });
  getComments({
    contentId,
    page: stateComment.page,
    size: stateComment.size
  }).then(response =>
    dispatch({
      type: LOAD_COMMENTS_COMPLETE,
      comments: response.comments,
      page: response.page,
      total: response.total,
      size: response.size,
      contentId
    })
  );
};

export const loadMoreComments = contentId => (dispatch, getState) => {
  const stateComment = {
    ...getState().news.comments,
    page: getState().news.comments.page + 1
  };

  if (peticionAcabada) {
    if (stateComment.content.length < stateComment.total) {
      peticionAcabada = false;
      getComments({
        contentId,
        page: stateComment.page,
        size: stateComment.size
      }).then(response => {
        dispatch({
          type: CHANGE_PAGE_COMMENTS,
          comments: response.comments,
          page: response.page,
          total: response.total,
          size: response.size,
          contentId
        });
        peticionAcabada = true;
      });
    }
  }
};

export const newComment = comment => (dispatch, getState) =>
  insertComment(comment).then(comment => {
    dispatch({ type: INSERT_COMMENT, comment: { ...comment, replies: [] } });
    return loadComments(comment.contentId)(dispatch, getState);
  });

export const loadAllReplies = commentId => dispatch =>
  getReplies(commentId).then(comments => {
    dispatch({ type: LOAD_ALL_REPLIES_COMMENT, comments, id: commentId });
    return comments;
  });

export const replyComment = data => dispatch =>
  insertComment(data).then(comment => {
    dispatch({ type: REPLY_COMMENT, comment: { ...data, ...comment } });
    return loadAllReplies(data.parentId)(dispatch);
  });

// removeComment(id) borra un comentario propio;
// removeComment(id, { generic: true }) borra uno de A3Mil (endpoint sadmin)
export const removeComment = (
  commentId,
  { generic = false } = {}
) => dispatch =>
  (generic ? deleteCommentA3mil : deleteComment)(commentId).then(() =>
    dispatch({ type: DELETE_COMMENT, id: commentId })
  );

export const likeNews = id => (dispatch, getState) => {
  const newsLike = getState().news.newsLike.find(item => id === item);

  if (newsLike) {
    deleteLike(id).then(() =>
      dispatch({
        type: UNLIKE_NEWS,
        id
      })
    );
  } else {
    postLike(id).then(() =>
      dispatch({
        type: LIKE_NEWS,
        id
      })
    );
  }
};

export const favoriteNews = id => (dispatch, getState) => {
  const newsFavorite = getState().news.newsFavorite.find(item => id === item);

  if (newsFavorite) {
    deleteReadLater(id).then(() =>
      dispatch({
        type: UNFAVORITE_NEWS,
        id
      })
    );
  } else {
    postReadLater(id).then(() => dispatch({ type: FAVORITE_NEWS, id }));
  }
};
